// Investor-demo mode. Activated ONLY by visiting the /demo route, which mints
// a throwaway demo candidate. While active, the Cmd+Option+Shift+S skip
// shortcut works inside the case simulation (and nowhere else) so the case
// can be fast-forwarded on prod without any dev env flags.
//
// sessionStorage keeps the flag tab-scoped: it dies with the tab and can
// never leak into a real candidate's session.

const DEMO_KEY = 'baba_demo_mode';

export const isDemoMode = (): boolean =>
  sessionStorage.getItem(DEMO_KEY) === 'true';

export const enableDemoMode = (): void => {
  sessionStorage.setItem(DEMO_KEY, 'true');
};
